import React, { forwardRef } from 'react';
import { IIconProps } from './IIconProps';

export const QuestionIcon = forwardRef<SVGSVGElement, IIconProps>(
	({ iconClass = '', title = '' }, ref) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 32 32"
			className={iconClass}
			fill="none"
			stroke="#fff"
			ref={ref}
		>
			{title && <title>{title}</title>}
			<path d="M22.544 3.573c-1.824-1.315-4.115-1.973-6.874-1.973-2.098 0-3.869 0.462-5.307 1.389-2.283 1.45-3.496 3.912-3.643 7.384h5.291c0-1.013 0.296-1.984 0.885-2.925 0.59-0.938 1.592-1.406 3.005-1.406 1.437 0 2.427 0.381 2.966 1.141 0.542 0.763 0.813 1.606 0.813 2.531 0 0.806-0.403 1.544-0.891 2.213-0.267 0.39-0.619 0.75-1.058 1.078 0 0-2.869 1.84-4.128 3.318-0.73 0.856-0.795 2.141-0.861 3.981-0.003 0.131 0.046 0.403 0.504 0.403 0.459 0 3.706 0 4.114 0 0.41 0 0.494-0.302 0.499-0.438 0.029-0.669 0.102-1.013 0.226-1.4 0.23-0.731 0.861-1.368 1.566-1.918l1.456-1.003c1.315-1.026 2.363-1.866 2.827-2.525 0.79-1.082 1.347-2.416 1.347-4-0.002-2.584-0.914-4.531-2.738-5.85zM15.586 23.878c-1.822-0.056-3.326 1.206-3.384 3.184-0.056 1.974 1.373 3.282 3.197 3.334 1.902 0.056 3.366-1.163 3.426-3.141 0.054-1.978-1.334-3.322-3.238-3.378z" />
		</svg>
	),
);
